import { Action } from "@/api-schema-enums";
import { Can, useAbility } from "@/casl-provider";
import { createRowNavigatePath } from "@/components/data-table/_helpers/create-row-navigate-path";
import { DepartmentTable } from "@/components/data-table/predefined/department-table";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";

const DEFAULT_PAGE_SIZE = 100;

export function DepartmentView() {
  const { t } = useTranslation(["common", "ram"]);
  const ability = useAbility();
  const canManage = ability.can(Action.Manage, "Department");
  const defaultRowActions = canManage
    ? undefined
    : {
        showEdit: false,
        showDelete: false,
        showRestore: false,
      };

  return (
    <Can I="read" a="Department">
      <CenteredLayout
        variant={CenteredLayoutVariant.Table}
        title={t("ram:Departments")}
        subTitle={t("common:SearchFilterAndManageEntriesDescription")}
      >
        <DepartmentTable
          pageSize={DEFAULT_PAGE_SIZE}
          showCreateButton={canManage}
          defaultRowActions={defaultRowActions}
          onRowNavigate={createRowNavigatePath("/masterdata/department")}
        />
      </CenteredLayout>
    </Can>
  );
}
